import { createFileRoute } from '@tanstack/react-router';
import { CMSRender } from '@/components/cms-render';
import { useEffect } from 'react';

export const Route = createFileRoute('/app/download')({
  component: () => <DownloadAppPage />,
});

function DownloadAppPage() {
  useEffect(() => {
    // Hide the chat widget when the page mounts
    if (window?.voiceflow?.chat) {
      window.voiceflow.chat.hide();
    }

    return () => {
      // Mount the chat widget again when the page unmounts
      if (window?.voiceflow?.chat) {
        window.voiceflow.chat.show();
      }
    };
  }, []);

  return <CMSRender />;
}
